export default {
  visitors: {},

  branches: [],
  branch: {},
  branchCode: null,

  fiscalYears: [],
  fiscalYear: {},

  users: [],
  user: {},
  userId: null,

  usersGroup: [],
  userGroup: {},

  roles: [],
  rolePermission: [],
  userRolePermission: {},

  branchYears: [],

  countries: [],
  countryMaxCode: null,

  provinces: [],
  provinceMaxCode: null,

  cities: [],
  cityMaxCode: null,

  region: [],
  regionMaxCode: null,

  personGroups: [],
  personGroupCode: null,

  persons: [],
  person: {},
  personBySearch: {},
  personNavigation: {},
  personCode: null,
  personId: null,
  personIsLegal: false,
  personEmployeeGroup: null,
  isPersonGenralGroup: null,

  personPosition: [],

  prefix: [],
  prefixCode: null,

  personFinancialInfo: [],
  personFinancialInfoCode: null,

  personTaxFiles: [],
  personTaxFilesCode: null,

  personContact: [],

  sbuTree: [],
  sbuList: [],

  floatAccountConfig: [],
  floatAccountGroup: [],
  floatGroupCodeOne: null,
  floatGroupCodeTwo: null,
  floatGroupCodeThree: null,
  floatGroupCodeFour: null,
  floatGroupCodeFive: null,

  floatAccountOne: [],
  floatAccountTwo: [],
  floatAccountThree: [],
  floatAccountFour: [],
  floatAccountFive: [],

  floatAccountCode: null,
  floatAccountCodeTwo: null,
  floatAccountCodeThree: null,
  floatAccountCodeFour: null,
  floatAccountCodeFive: null,

  companyBoard: [],
  companyBoardCode: null,

  userLimitPersons: [],
  userLimitFloatAccountsOne: [],
  userLimitFloatAccountsTwo: [],
  userLimitFloatAccountsThree: [],
  userLimitFloatAccountsFour: [],
  userLimitFloatAccountsFive: [],

  positionInfo: [],
  positionCode: null,
  cartableConfirmPriority: [],

  signatureDetail: [],

  imageBrnach: [],

  personByMobile: {},

  transactionInfo: [],

  currencyTypes: {},
  currencyTypeCode: null,

  currencyRates: {},

  vehicleType: [],

  suppliers: [],
  supplier: {},
  supplierByPerson: {},

  buyers: [],
  buyer: {},
  buyerByPerson: {},

  smsSetting: [],

  settings: [],

  contractors: [],

  branchesAndOffices: [],
  branchesAndOfficesById: {},
  branchesAndOfficesCode: null,

  saleAddMinus: [],
  saleAddMinusById: {},
  saleAddMinusMaxCode: null,
  saleAddMinusPriority: null,

  buyAddMinuses: [],
  buyAddMinus: {},
  buyAddMinusCode: null,
  buyAddMinusPriority: null,
  buyAddMinusNavigation: {},
  buyAddMinusSearch: {},

  banks: [],
  bankMaxCode: null,

  bankBranches: [],
  bankBranchMaxCode: null,
  bankBranchCode: null,

  documentTypes: [],
  documentTypesById: {},
  documentTypesMaxCode: null,

  companies: [],
  company: {},

  userBranches: [],

  insuranceType: [],
  insuranceTypeById: [],
  insuranceTypeCode: null,

  employmentType: [],
  employmentTypeById: [],
  employmentTypeCode: null,

  studyFieldType: [],
  studyFieldTypeById: [],
  studyFieldTypeCode: null,

  degree: [],
  degreeById: [],
  degreeCode: null,

  departments: [],
  departmentById: [],
  departmentCode: null,

  personnels: [],
  personnelById: [],
  personnelBySearch: [],
  personnelCode: null,
  personnelId: null,
  personnelNavigation: {},

  serviceCenters: [],
  serviceCenterById: [],
  serviceCenterCode: null,

  unitCount: [],
  unitCountCode: null,

  voucherTemplate: [],

  posTerminals: [],
  posTerminalTypes: [],
  connectionTypes: [],

  benefitCards: [],
  benefitCardTypes: [],
  benefitCardTransactions: [],
  benefitCardTransactionTypes: [],
};
